/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Soyun Lee (sylee2@rsupport.com)
 *
 * @description
 *
 * @created at Mon Oct 28 2024
 **/

import { _T, _P } from "@rfice/language";
import { Button, Column, Typography } from "@/frameworks/designStuff/components";

import { useXRMNavigate } from "@/frameworks/core/hooks";

export default function EncourageSignupPanel({ panelType }: { panelType: "MEETING" | "PEOPLE" | "CHAT" | "CALL" }) {
	const { navigate } = useXRMNavigate();

	return (
		<Column gap={12} horizonAlign="center" verticalAlign="center" style={{ height: "100%" }}>
			<Typography typoSize="Body3" typoColor="neutral_70_100" align="center">
				{panelType === "CHAT"
					? _P("Rfice 가입 후 사람들에게 인사 메시지를 보내보세요.")
					: panelType === "CALL"
						? _P("Rfice 가입 후 자주 연락하는 사람을 등록하고 <br/>바로 연락해보세요.")
						: _P("Rfice 가입 후 그룹을 만들거나 가입하여 <br/> 그룹 멤버들과 Rfice를 함께 즐겨보세요.")}
			</Typography>

			<Button
				size="small"
				filled="gradient"
				typoColor="neutral_00_100"
				shape="circle"
				onClick={() => navigate("/join")}
				style={{ padding: "0 20px", minWidth: "80px" }}
			>
				{_T("Rfice 가입")}
			</Button>
		</Column>
	);
}
